import { Box, MenuItem, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { H2, Icon, P1R, P3, TextLink } from 'src/components';
import { useState } from 'react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { themeColors } from 'src/theme';
import { useTranslation } from 'react-i18next';
import { TenantForSharedUserType } from 'src/types/tenant';
import { UserStatus } from 'src/shared/enums/userStatus.enum';
import { StyledDivider, StyledIconButton, StyledMenu, StyledContractorCard, ContractorInfoContainer, LabelContainer } from './styled';

type ContractorCardPropsType = {
  tenant: TenantForSharedUserType;
  onAccept: (id: number) => void;
};

function ContractorCard({ tenant, onAccept }: ContractorCardPropsType) {
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();
  const isReviewingLabelNeeded =
    tenant.isAccepted && (tenant.approvalStatus === UserStatus.DEACTIVATED || tenant.approvalStatus === UserStatus.APPROVED);

  const handleMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <StyledContractorCard>
      {!tenant.isAccepted && (
        <Box sx={{ position: 'relative', width: '100%' }}>
          <StyledIconButton onClick={handleMenuOpen} sx={{ position: 'absolute', right: 10, top: 10 }}>
            <MoreHorizIcon sx={{ color: themeColors.black }} />
          </StyledIconButton>
        </Box>
      )}

      {isReviewingLabelNeeded && (
        <Box sx={{ position: 'relative', width: '100%' }}>
          <LabelContainer>
            <P3>Reviewing</P3>
          </LabelContainer>
        </Box>
      )}

      <ContractorInfoContainer>
        {tenant.logoUrl ? (
          <img style={{ height: '42px', width: '42px', borderRadius: '50%', marginBottom: '32px' }} src={tenant.logoUrl} alt="tenantLogo" />
        ) : (
          <Icon sx={{ mb: 4 }} name="tenantLogo" />
        )}
        <H2 sx={{ textWrap: 'wrap', textAlign: 'center', mb: 3 }}>{tenant.title}</H2>
        <TextLink sx={{ color: themeColors.grayDark }}>{tenant.address1.city}</TextLink>
      </ContractorInfoContainer>

      <StyledDivider />

      <Box sx={{ padding: 3 }}>
        <Link component={RouterLink} to={`/contractors/${tenant.id}`} sx={{ textDecoration: 'none', cursor: 'pointer' }}>
          <TextLink sx={{ color: themeColors.blue }}>{t('contractorsPage.viewDetailsButton')}</TextLink>
        </Link>
      </Box>

      <StyledMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem component="button" onClick={() => onAccept(tenant.id)} sx={{ padding: '10px', width: '100%' }}>
          <Icon name="accepted" />
          <P1R>{t('contractorsPage.acceptButton')}</P1R>
        </MenuItem>
      </StyledMenu>
    </StyledContractorCard>
  );
}

export default ContractorCard;
